<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ReportingEntityApi from '../../api/ReportingEntityApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import ValidationPeriodApi from '../../api/ValidationPeriodApi'
import VfeApi from '../../api/VfeApi'
import FormAccessApi from '../../api/FormAccessApi'
import ActivityLogsApi from '../../api/ActivityLogsApi'

/** UI Components */
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Autocomplete } from 'buefy/dist/components/autocomplete'

const VCARD_SECTION_LOG = 'Validation Card';
const VFE_SECTION_LOG = 'Validation Card - Form Entry';

export default {
    name : "VcardMgtView",
    components: {
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-autocomplete' : Autocomplete
    },
    computed : {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        }),
        filteredEntities(){
            if (!this.keyword) {
                return this.entities;
            } 
            var regExp = new RegExp(this.keyword,'i')
            return this.entities.filter((option) => {
                return option.reportingEntity
                    .toString()
                    .toLowerCase()
                    .match(regExp)
            })
        }
    },
    data(){
        return {
            isLoading: false,
            globalLoading: null,
            errorData : null,
            entities: [],
            selectedEntity: null,
            selectedEntityId: null,
            keyword: '',
            activeVcards: [],
            selectedReportingYear: null,
            currentYear: null,
            reportingYearLov: [],
            selectedValidationCardId: null,
            vcardForms: [],
            entityFormAccess: []
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        if (this.profile.role.match(/admin/gi)) {    
            this.isTokenValid();
            this.getData()   
        } else {
            this.$router.push({path:'/dashboard'});
            this.$dialog.alert({
                title: 'Error',
                message: "Unable to proceed. This page is restricted.",
                type: 'is-danger'
            });
        }
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData", 
            setProfile : "updateUserProfile"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                this.getReportingYearLov()
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getData(){
            this.showLoading()
            this.entities = []
            ReportingEntityApi.get()
            .then(response => {
                this.closeLoading()
                if (response.data) {
                    if (!response.data.error) {
                        this.entities = response.data
                        // this.selectedEntity = this.entities[0]
                    }
                    else {
                        this.promptServerError({response},'ReportingGroup.getAllData');
                    }
                }
            })
            .catch(error => {
                this.closeLoading
                this.promptServerError(error,'ReportingGroup.getAllData');
            });
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            if (this.globalLoading !== null) {
                this.globalLoading.close()
            }
            this.globalLoading = null
        },
        showInlineError (title, msg) {
            this.errorData = {};
            this.errorData.title = title
            this.errorData.message = msg
        },
        closeInlineError() {
            this.errorData = null
        },
        selectEntity(option) {
            this.selectedEntity = option
            this.selectedEntityId = option.repEntityId
            this.keyword = option.reportingEntity
            
            this.getActiveValidationCards()
        },
        getReportingYearLov(){
            this.reportingYearLov = [];
            let staticYrs = AppResourceUtil.getRepYrStaticLov();
    
            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {

                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (repYearInDb.length > 0) {
                            try {
                                /* Pre-select the year with data (from DB) */ 
                                this.selectedReportingYear = repYearInDb[0];
                                this.currentYear = repYearInDb[0];
                            }
                            catch(yrErr){}
                        }

                        if (this.selectedReportingYear != null) {
                            this.getValidationPeriod();
                        }
                        else {
                            /** If there's no selected year, stop loading indicator */
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        selectReportingYear(year){
            this.selectedValidationCard = null
            this.selectedValidationCardId = null
            this.currentYear = year;
            this.keyword = ''
            this.activeVcards = []
            this.selectedEntity = null
            this.selectedEntityId = null
            this.getData()
        },  
        getValidationPeriod(){
            if (!this.selectedReportingYear) {
                return false;
            }
            /** This is called to get the due date and show timer in workspace */
            this.validationPeriod = null;

            ValidationPeriodApi.get({
                reportingYear : this.selectedReportingYear,
                status : ''
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length == 0) {
                            // No validation period
                        }
                        else {
                            if (response.data[0]) {
                                this.validationPeriod  = response.data[0];
                            }  
                        }
                    }
                    else {
                        this.promptServerError({response},'ValidationPeriod.get');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ValidationPeriod.get');
            });
        },
        getActiveValidationCards(){
            this.activeVcards = []

            ValidationCardApi.getPerUser({
                userId : this.profile.userId,
                repGroupIdFk : null,
                repGroupData: [
                    {
                        repGroupIdFk: this.selectedEntity.repGroupIdFk
                    }
                ],
                repEntityIdFk : null,
                repEntityData: [
                    {
                        repEntityIdFk: this.selectedEntity.repEntityId
                    }
                ],
                repUnitIds: this.selectedEntity.reportingUnits,
                repUnitData: this.selectedEntity.reportingUnits,
                reportingYear : this.selectedReportingYear
            })
            .then(response=>{
                let cards = response.data;
                if (response.data) {
                    if (!response.data.error) {
                        if (cards.entityLevelValidationCards.length > 0 ||
                            cards.unitLevelValidationCards.length > 0) {
                            this.activeVcards = [
                                ...cards.entityLevelValidationCards,
                                ...cards.unitLevelValidationCards
                            ]
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getPerUser');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getPerUser');
            });
        },
        openVcard(card) {
            this.selectedValidationCardId = card.validationCardId
            this.getFormsAccess()
            this.getValidationCard()
        },
        getFormsAccess(){
            this.entityFormAccess = [];
            let repEntityIdFk = this.selectedEntity.repEntityId
            let repUnitIds = []

            FormAccessApi.getEntityAccess({
                userId : this.profile.userId,
                repGroupIdFk : this.selectedEntity.repGroupIdFk,
                reportingYear : this.selectedReportingYear,
                repEntityIdFk,
                repUnitIds
            })
            .then(response=>{

                if (response.data) {
                    if (!response.data.error) {
                        
                        var formAccess = response.data;
                        if (formAccess.reportingEntityLevel.length > 0 ||
                            formAccess.reportingUnitLevel.length > 0) {

                            // Filter forms for selected year
                            let entAccForYr = [], unitAccForYr = [];
                            if (formAccess.reportingEntityLevel.length > 0) {
                                entAccForYr = formAccess.reportingEntityLevel.filter(acc=>{
                                    return acc.reportingYear==this.selectedReportingYear;
                                });
                            }

                            if (formAccess.reportingUnitLevel.length > 0) {
                                unitAccForYr = formAccess.reportingUnitLevel.filter(acc=>{
                                    return acc.reportingYear==this.selectedReportingYear;
                                });
                            }

                            if (entAccForYr.length > 0 || unitAccForYr.length > 0) {
                                this.entityFormAccess = entAccForYr
                                console.log(unitAccForYr)
                            }
                            else {
                                this.closeLoading()
                                this.$dialog.alert({
                                    title: 'Warning',
                                    message: `Ooops! Looks like there are NO FORMS mapped to your access for selected year
                                        `+this.selectedReportingYear+`. <br><br>If this is NOT expected, please contact the Secretariat.`,
                                    type: 'is-warning'
                                });
                                return false;
                            }
                            
                        }
                        else {
                            this.closeLoading()
                            this.$dialog.alert({
                                title: 'Warning',
                                message: `Ooops! Looks like there are NO FORMS mapped to your access for selected year
                                    `+this.selectedReportingYear+`. If this is NOT expected, please contact the Secretariat.`,
                                type: 'is-warning'
                            });
                            return false;
                        }
                    }
                    else {
                        this.closeLoading()
                        this.promptServerError({response},'FormAccess.getUserAccess');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'FormAccess.getUserAccess');
            });
        },
        getValidationCard(){
            if (!this.selectedValidationCardId) {
                return false;
            }
            this.vcardForms = [];
            this.showLoading()
            ValidationCardApi.get(this.selectedValidationCardId)
            .then(response=>{
                this.closeLoading()
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.validationCard.length == 1) {
                            this.selectedValidationCard = response.data.validationCard[0];
                        }
                        this.selectedReportingYear = this.selectedValidationCard.reportingYear;
                        this.vcardLogs = [];

                        /** Convert dates */
                        var vcardForms = response.data.uniqueForms;
                        vcardForms.forEach(vform=>{
                            if (vform.vfe.length > 0) {
                                vform.vfe.forEach(vcardFormEntry=>{
                                    vcardFormEntry.dateLastUpdated = AppResourceUtil.convertDate(vcardFormEntry.dateLastUpdated)
                                    vcardFormEntry.dateGenerated = AppResourceUtil.convertDate(vcardFormEntry.dateGenerated)
                                })
                            }
                        })
                        this.vcardForms = vcardForms;
                        console.log(vcardForms)
                    }
                    else {
                        this.promptServerError({response},'ValidationCard.get');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'ValidationCard.get');
            });
        },
        inVcardEntry(access) {
            var res = this.vcardForms.filter(f=> {
                return f.accessIdFk === access.accessId
            })
            if (res.length > 0) {
                return true
            }
            return false
        },
        addVfe(access){
            let vfeArr = [];            
            // Prepare entity-level fields for creation
            vfeArr.push({
                validationCardIdFk : this.selectedValidationCardId,
                accessIdFk : access.accessId,
                reportingYear : this.selectedValidationCard.reportingYear,
                generatedBy : this.profile.userId
            });
            this.showLoading()
            
            VfeApi.add(vfeArr)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error &&
                        response.data.isAdded) {
                        this.closeLoading()
                        
                        this.$notification.open({
                            duration: 5000,
                            message: 'Form entry created.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        if (this.selectedValidationCardId!=null) {
                            // Log validation card creation
                            this.logCardMovement({
                                validationCardIdFk : this.selectedValidationCardId,
                                vfeIdFk : null,
                                activityByUser : this.profile.userId,
                                activitySection : VCARD_SECTION_LOG,
                                activityMessageLog : "Form entry generated for "+access.formName+"."
                            });
                        }
                        this.openVcard(this.selectedValidationCard)
                    }
                    else {
                        this.closeLoading()
                        this.promptServerError({response},'Vfe.add');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'Vfe.add');
            });
        },
        logCardMovement(logData) {
            ActivityLogsApi.add(logData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error &&
                        response.data.logId) {
                        /** Success */
                    }
                    else {
                        this.promptServerError({response},'ActivityLogs.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ActivityLogs.add');
            });
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Cards and Access</p>
        
        <section class="section no-padd--top"> 
            
            <div class="field is-grouped">
                <div class="control">
                    <b-dropdown
                        v-model="selectedReportingYear">
                        <button class="button is-primary is-outlined"
                            type="button"
                            slot="trigger">
                            <template
                                v-if="selectedReportingYear">
                                <strong>Reporting Year ({{selectedReportingYear}})</strong>
                            </template>
                            <template
                                v-else>
                                <strong>Select Reporting Year</strong>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="(year,yearIdx) in reportingYearLov"
                            v-bind:key="yearIdx"
                            v-bind:value="year"
                            v-on:click="selectReportingYear">
                            <h4>{{year}}</h4>
                        </b-dropdown-item>
                        
                    </b-dropdown>
                </div>
                <div class="control"
                    style="width:300px"> 
                    <b-autocomplete
                        icon="magnify"
                        placeholder="Choose Validation Card"
                        v-model="keyword"
                        v-bind:data="filteredEntities"
                        v-bind:open-on-focus="true"
                        v-on:select="selectEntity"
                        :clearable="true"
                        field="displayedEntityName"
                        :max-height="'280px'">
                        <template slot-scope="props">
                            <span class="title is-6">{{props.option.repEntityId}} - {{props.option.reportingEntity}}</span><br/>
                            <!-- <span class="has-text-weight-ligh">ID: {{props.option.repEntityId}}</span><br/> -->
                            <span class="tag"
                                v-bind:class="props.option.repGroupTagClass">{{props.option.reportingGroup}}</span>
                        </template>
                        <template slot="empty">No results found</template>
                    </b-autocomplete>
                </div>
            </div>

            <div class="notification is-danger"
                v-if="errorData!=null">
                <button class="delete"
                    type="button"
                    v-on:click="closeError"></button>
                <strong>Error: {{errorData.title}}</strong>
                <p>{{errorData.message}}</p>
            </div>

            <section class="section app-view">

                <div class="columns">
                    <div class="column is-3">
                        <p class="subtitle">Active Validation Cards</p>
                        <div v-if="activeVcards.length > 0">
                            <div class="box clickable"
                                v-for="(card,cardIdx) in activeVcards"
                                v-bind:key="cardIdx"
                                @click="openVcard(card)">
                                <div>
                                    <p class="heading">
                                        {{card.cardLevel}} &nbsp; (ID: {{card.validationCardId}})
                                    </p>
                                    <p class="drag-item-text drag-item-name">
                                        {{card.reportingUnit ? card.reportingUnit : card.reportingEntity}}
                                    </p>
                                    <span class="tag"
                                        v-bind:class="'tag--'+card.validationCardStatusClass">{{card.validationCardStatus}}</span>
                                </div>
                                <div class="columns">
                                    <div class="column">
                                        <p class="heading">No. of Entries</p>
                                        <span class="title is-5">{{card.numFormEntries}}</span>
                                    </div>
                                    <div class="column has-text-right">
                                        <p class="heading">No. of Forms</p>
                                        <p class="tag"
                                            v-bind:class="{
                                                'is-success':card.completionPercentage==100,
                                                'is-light':card.completionPercentage<100
                                            }">{{card.completedForms}} / {{card.numForms}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <span>No validation cards found.</span>
                        </div>
                    </div>
                    <div class="column"
                        v-if="selectedValidationCardId">
                        <p class="subtitle">Validation Card Forms and Entries ({{vcardForms.length}})</p>
                        <ul v-if="vcardForms.length"
                            style="max-height:400px;overflow-y:scroll;padding-bottom:0.6rem">
                            <li v-for="(form,formIdx) in vcardForms"
                                v-bind:key="formIdx"
                                style="margin-top:0.5rem;padding:0.4rem">
                                <div class="box">
                                    <span class="tag is-grey has-text-success"
                                        v-if="form.formSubmissionType!='Single'">
                                        {{form.formSubmissionType}}
                                    </span> 
                                    <div>
                                        Form Name: <strong>{{form.formName}}</strong>
                                    </div>                                    
                                    <div v-if="form.vfe && form.vfe.length > 0"
                                        style="margin-top:0.7rem">
                                        <div
                                            v-for="(entry,entryIdx) in form.vfe"
                                            v-bind:key="entryIdx"
                                            style="border:none;border-top:1px solid #e5e5e5;padding-top:0.4rem;margin-bottom:0.5rem;">
                                            <p><strong>Entry ID:</strong> {{entry.vcardFormEntryId}}</p>
                                            <p><strong>Last Updated by:</strong> {{entry.lastUpdatedByName}} on {{entry.dateLastUpdated}}</p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div v-else>
                            No forms/entries found.
                        </div>
                    </div>
                    <div class="column"
                        v-if="selectedValidationCardId">
                        
                        <p class="subtitle">Form Access ({{entityFormAccess.length}})</p>
                        <ul v-if="entityFormAccess.length"
                            style="max-height:400px;overflow-y:scroll;padding-bottom:0.6rem">
                            <li v-for="(access,accessIdx) in entityFormAccess"
                                v-bind:key="accessIdx"
                                style="margin-top:0.5rem;padding:0.4rem;border-bottom:1px solid #e5e5e5">
                                <div class="columns">
                                    <div class="column">
                                        Form Name: <strong>{{access.formName}}</strong><br/>
                                        Access ID: {{access.accessId}} <br/>
                                    </div>
                                    <div class="column is-4">
                                        <button
                                            class="button is-success"
                                            v-if="inVcardEntry(access)==false"
                                            @click="addVfe(access)">
                                            Create Entry
                                        </button>
                                    </div>
                                </div>
                                
                            </li>
                        </ul>
                        <div v-else>
                            No access found.
                        </div>
                    </div>
                </div>  
                
            </section>
            
        </section>  

        
    </section>
</template>

<style scoped>
.collapse-header {
    background-color: whitesmoke;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/CardAccessView.vue